import { toSlug } from "./index"
export default function createPathProto(prefix = "") {
    return {
        get path() {
            return prefix + toSlug(this.name);
        },
    };
}
